import { Component, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { SiteAlertService } from '@accounts/services/site-alert.service';
import {
  NotificationDetails,
  NotificationMessage,
} from '@accounts/accounts-alerts/accounts-alerts.interface';
import { takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';

@Component({
  selector: 'ft-site-alert',
  templateUrl: './site-alert.component.html',
})
export class SiteAlertComponent implements OnDestroy {
  /**
   * The Notification details
   */
  siteAlerts$: Observable<NotificationMessage[]>;
  notificationDetails: NotificationDetails;

  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private cd: ChangeDetectorRef,
    public siteAlertService: SiteAlertService
  ) {
    this.siteAlerts$ = this.siteAlertService.siteAlertOutput$;

    // detect changes after observable emits new value
    this.siteAlerts$.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.cd.detectChanges();
    });
  }

  closeSiteAlert(notificationDetails: NotificationDetails): void {
    this.siteAlertService.removeSiteAlert(notificationDetails);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
